import { render, staticRenderFns } from "./PrimaryButtonBlock.vue?vue&type=template&id=317c3109&"
import script from "./PrimaryButtonBlock.vue?vue&type=script&lang=js&"
export * from "./PrimaryButtonBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports